import gql from 'graphql-tag';

export const canDisplayKiperAccessibility = gql`
  query canDisplayKiperAccessibility($accessId: ID!) {
    canDisplayKiperAccessibility(accessId: $accessId) {
      isAccessibilityKiper
    }
  }
`;
